var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-found"},[_c('p',[_vm._v("Not Found / Error 404")]),_c('a',{on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v(" "+_vm._s(_vm.$t('message.notfound.volver'))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }